import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useCountry } from "../Context/CountryContext";
import { getCountryCodeFromPath } from "./countryConfig";

/**
 * Supports both explicit landing routes and dynamic country-scoped routes.
 */
const CountryRoute = ({ countryCode, children }) => {
  const params = useParams();
  const { country, activateCountry } = useCountry();

  const countryFromUrl = params.countryCode
    ? getCountryCodeFromPath(`/${params.countryCode}`)
    : null;

  const resolvedCountryCode = countryCode || countryFromUrl;

  useEffect(() => {
    if (resolvedCountryCode) {
      activateCountry(resolvedCountryCode);
    }
  }, [activateCountry, resolvedCountryCode]);

  if (!resolvedCountryCode) {
    return <Navigate to="/" replace />;
  }

  // Avoid briefly rendering a page with the previous country's context.
  if (country?.code !== resolvedCountryCode) {
    return null;
  }

  return children;
};

export default CountryRoute;



// import { useEffect } from "react";
// import { useCountry } from "../Context/CountryContext";

// const CountryRoute = ({ countryCode, children }) => {
//   const { activateCountry } = useCountry();

//   useEffect(() => {
//     activateCountry(countryCode);
//   }, [activateCountry, countryCode]);

//   return children;
// };

// export default CountryRoute;
